import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import TableButton from 'components/TableButton';
import TableActionsWrapper from 'components/TableActionsWrapper';

import hashIds from 'services/hashIds';

interface CustomerActionsProps {
  selectedCount: number;
  loading: boolean;
  selectedRows: {
    idCliente: number;
  }[];
}

const CustomerActions: React.FC<CustomerActionsProps> = ({
  loading,
  selectedCount,
  selectedRows,
}) => {
  const { t } = useTranslation();

  const customerHashId = hashIds.encode(selectedRows[0].idCliente);

  return (
    <TableActionsWrapper loading={loading}>
      {selectedCount === 1 && (
        <>
          <TableButton
            forwardedAs={Link}
            to={`/painel/${customerHashId}`}
            className="mx-1"
            target="_blank"
            disabled={loading}
          >
            {t('pages:customers.customerDashboard')}
          </TableButton>
          <TableButton
            forwardedAs={Link}
            to={`/venda/${customerHashId}`}
            className="mx-1"
            disabled={loading}
          >
            {t('common:sell')}
          </TableButton>
        </>
      )}
    </TableActionsWrapper>
  );
};

export default CustomerActions;
